"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storage_blob_1 = require("@azure/storage-blob");
var dexie_db_1 = __importDefault(require("./dexie-db"));
var Auth_1 = __importDefault(require("../Auth"));
var SounditiApi_1 = __importDefault(require("../SounditiApi"));
var defaults_1 = __importDefault(require("../defaults"));
var utils_1 = require("../utils/utils");
var errors_1 = require("../utils/errors");
var logger_1 = __importDefault(require("../utils/logger"));
var fetch_progress_1 = __importDefault(require("fetch-progress"));
var logger = logger_1.default('file-access');
/**
 * Provides access to the user files
 * @class
 *
 * @param {string} [hosts = defaults] | the api host
 *
 * @category DataLayers
 *
 * @todo implement localDB to easy data access costs
 */
var FileAccess = /** @class */ (function () {
    function FileAccess(_a) {
        var _b = (_a === void 0 ? {} : _a).hosts, hosts = _b === void 0 ? defaults_1.default : _b;
        this._authRenewal = utils_1.tokenRenewal;
        this.auth = new Auth_1.default({ auth_host: hosts.auth_host });
        this.token = this.auth.getToken() || '';
        this.api = new SounditiApi_1.default({ token: this.token, hosts: hosts });
        this.table = 'files';
    }
    /**
     * Lists all files owned by the authtenticated user
     *
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<FileQuery>} A file list
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    FileAccess.prototype.listFiles = function (renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, list, files, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.listFiles()];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        list = _a.sent();
                        return [2 /*return*/, list];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.listFiles(false)];
                    case 5:
                        files = _a.sent();
                        return [2 /*return*/, files];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_1 = _a.sent();
                        throw new errors_1.PermissionError(error_1.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Lists all files owned by the authtenticated user
     *
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<FileQuery>} A file list
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    FileAccess.prototype.listFilmFiles = function (fileName, renew) {
        if (fileName === void 0) { fileName = ""; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, list, files, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.listFilmFiles(fileName)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        list = _a.sent();
                        return [2 /*return*/, list];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.listFilmFiles(fileName, false)];
                    case 5:
                        files = _a.sent();
                        return [2 /*return*/, files];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_2 = _a.sent();
                        throw new errors_1.PermissionError(error_2.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Gets an access URL filename owned by the authtenticated user
     * if exists
     *
     * @param {string} fileName The file name
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     * @example
     *
     * const { fileName } = 'MyFile.mp4';
     * const fileAccess = new FileAccess({ host: 'http://localhost:4000/dev'});
     * try {
     *       const {uri} = await fileAccess.getFile(fileName);
     *       // reload a video HTML tag element
     *       document.getElementById("video-tag").load();
     *   } catch (error) {
     *       console.log('ERROR',error)
     *   };
     *
     */
    FileAccess.prototype.getFile = function (fileName, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, sas, campaigns, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.getSharedAccessSignature(fileName)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        sas = _a.sent();
                        return [2 /*return*/, sas];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getFile(fileName, false)];
                    case 5:
                        campaigns = _a.sent();
                        return [2 /*return*/, campaigns];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_3 = _a.sent();
                        throw new errors_1.PermissionError(error_3.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Test method for preloading assets in the indexedDB local storage.
     * It tries to retrieve the file from local or dowload and stores the assets.
     * Either way it returns a local blob url.
     *
     * @param {string} fileName The name of the file
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    FileAccess.prototype.getOfflineFile = function (fileName, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var blob, blobFromDb, error_4, res, sas, res2, fileItem, error_5, campaigns, error_6, blobURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        blobFromDb = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).where('fileName').equals(fileName).toArray()];
                    case 2:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.log('db error getOfflineFile 1', { error: error_4 });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 21];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 19, , 20]);
                        return [4 /*yield*/, this.api.getSharedAccessSignature(fileName)];
                    case 6:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 14];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas.uri)];
                    case 8:
                        res2 = _a.sent();
                        return [4 /*yield*/, res2.blob()];
                    case 9:
                        blob = _a.sent();
                        fileItem = {
                            id: fileName,
                            fileName: fileName,
                            storedAt: Date.now(),
                            blob: blob
                        };
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).put(fileItem)];
                    case 11:
                        _a.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        error_5 = _a.sent();
                        console.log('db error getOfflineFile 2', { error: error_5 });
                        return [3 /*break*/, 13];
                    case 13: return [3 /*break*/, 18];
                    case 14:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 17];
                        return [4 /*yield*/, this._authRenewal()];
                    case 15:
                        _a.sent();
                        return [4 /*yield*/, this.getOfflineFile(fileName, false)];
                    case 16:
                        campaigns = _a.sent();
                        return [2 /*return*/, campaigns];
                    case 17: throw new errors_1.PermissionError('Invalid access token');
                    case 18: return [3 /*break*/, 20];
                    case 19:
                        error_6 = _a.sent();
                        throw new Error(error_6.message);
                    case 20: return [3 /*break*/, 22];
                    case 21:
                        blob = blobFromDb[0].blob;
                        _a.label = 22;
                    case 22: return [4 /*yield*/, URL.createObjectURL(blob)];
                    case 23:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    /**
     * Test method for preloading assets in the indexedDB local storage
     * it tries to retrieve the file from local or dowload and stores the assets.
     * either way returns a local blob url.
     *
     * @param {string} fileName
     * @param {function} progress A callback function with the progress
     *
     * @returns {Promise<SAS>}  Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    FileAccess.prototype.getOfflineFilmFile = function (getOfflineFilmFileRequest, progress, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var fileName, linkUrl, compressed, id, blob, blobFromDb, error_7, res, sas, campaigns, error_8, blobURL;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileName = getOfflineFilmFileRequest.fileName, linkUrl = getOfflineFilmFileRequest.linkUrl, compressed = getOfflineFilmFileRequest.compressed;
                        id = linkUrl ? fileName + '-' + linkUrl : compressed ? fileName + '-compressed' : fileName;
                        blobFromDb = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').where('fileName').equals(id).toArray()];
                    case 2:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        console.log('db error getOfflineFilmFile 1', { error: error_7 });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 16];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 14, , 15]);
                        return [4 /*yield*/, this.api.getFilmFile(getOfflineFilmFileRequest)];
                    case 6:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 9];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        sas = _a.sent();
                        console.log(1);
                        console.log({ sas: sas });
                        console.log(1);
                        return [4 /*yield*/, fetch(sas.url).then(fetch_progress_1.default({
                                onProgress: function (e) {
                                    if (progress)
                                        progress(e);
                                },
                            })).then(function (res2) { return res2.blob(); }).then(function (blobResponse) { return __awaiter(_this, void 0, void 0, function () {
                                var fileItem, error_9;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            blob = blobResponse;
                                            fileItem = {
                                                id: id,
                                                fileName: id,
                                                storedAt: Date.now(),
                                                blob: blob
                                            };
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, dexie_db_1.default.table('files').put(fileItem)];
                                        case 2:
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_9 = _a.sent();
                                            console.log('db error getOfflineFilmFile 2', { error: error_9 });
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 8:
                        _a.sent();
                        return [3 /*break*/, 13];
                    case 9:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this._authRenewal()];
                    case 10:
                        _a.sent();
                        return [4 /*yield*/, this.getOfflineFilmFile(getOfflineFilmFileRequest, progress, false)];
                    case 11:
                        campaigns = _a.sent();
                        return [2 /*return*/, campaigns];
                    case 12: throw new errors_1.PermissionError('Invalid access token');
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        error_8 = _a.sent();
                        throw new errors_1.PermissionError(error_8.message);
                    case 15: return [3 /*break*/, 17];
                    case 16:
                        blob = blobFromDb[0].blob;
                        _a.label = 17;
                    case 17: return [4 /*yield*/, URL.createObjectURL(blob)];
                    case 18:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    /**
     * Uploads a blob object to a determined Azure blob storage account
     * whit optional metadata
     *
     * @param {File} file A file object
     * @param {function} progress A callback function with the progress
     * @param {object} [metadata= {}] Key Value metadata parameters
     *
     * @returns {Promise<BlobUploadCommonResponse>} Blob upload information
     *
     * @throws {UploadError} An error when uploading
     *
     * @todo Check for speedSummary support ==> Ask microsoft directly
     *
     * @example
     * const fileAccess = new FileAccess({ host: 'http://localhost:4000/dev'})
     * const metadate = {
     *   OneKey: 'foo',
     *   AnotherKey: 'bar'
     * }
     * fileAccess.upload(file, metadate)
     */
    FileAccess.prototype.upload = function (file, progress, metadata) {
        if (progress === void 0) { progress = function () { }; }
        if (metadata === void 0) { metadata = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var res, _a, token, uri, blockblobService, response, error_10;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.puSharedAccessSignature(file.name)];
                    case 1:
                        res = _b.sent();
                        logger.debug('Res', { res: res });
                        return [4 /*yield*/, res.json()];
                    case 2:
                        _a = _b.sent(), token = _a.token, uri = _a.uri;
                        logger.debug('BlobUri', { token: token, uri: uri });
                        blockblobService = new storage_blob_1.BlockBlobClient(uri);
                        response = blockblobService.uploadData(file, {
                            onProgress: function (e) { return progress(e); },
                            metadata: metadata,
                            maxSingleShotSize: 4 * 1024 * 1024
                        });
                        return [2 /*return*/, response];
                    case 3:
                        error_10 = _b.sent();
                        logger.error('Upload error', { error: error_10 });
                        throw new errors_1.UploadError(error_10.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Uploads a blob object to a determined Google Cloud storage account
     *
     * @param {File} file A file object
     * @param {function} progress A callback function with the progress
     * @param {object} [metadata= {}] Key Value metadata parameters
     *
     * @returns {Promise<BlobUploadCommonResponse>} Blob upload information
     *
     * @throws {UploadError} An error when uploading
     *
     * @todo Check for speedSummary support ==> Ask microsoft directly
     *
     * @example
     * const fileAccess = new FileAccess({ host: 'http://localhost:4000/dev'})
     * const metadate = {
     *   OneKey: 'foo',
     *   AnotherKey: 'bar'
     * }
     * fileAccess.upload(file, metadate)
     */
    FileAccess.prototype.uploadFilm = function (file, progress) {
        if (progress === void 0) { progress = function () { }; }
        return __awaiter(this, void 0, void 0, function () {
            var res, url, axios, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.api.putFilmFile(file.name)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        url = (_a.sent()).url;
                        axios = require('axios').default;
                        return [4 /*yield*/, axios.request({
                                method: "PUT",
                                url: url,
                                mode: "cors",
                                headers: { 'content-type': 'application/octet-stream' },
                                data: file,
                                onUploadProgress: function (e) {
                                    progress(e);
                                }
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, url];
                    case 4:
                        error_11 = _a.sent();
                        logger.error('Upload error', { error: error_11 });
                        throw new errors_1.UploadError(error_11.message);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Test method for preloading assets in the indexedDB local storage.
     * It tries to retrieve the file from local or dowload and stores the assets.
     * Either way it returns a local blob url.
     *
     * @param {string} fileName The name of the file
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    FileAccess.prototype.getOfflineInteractionFile = function (campaignId, fileName, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var blob, blobFromDb, error_12, res, sas, res2, fileItem, error_13, campaigns, error_14, blobURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        blobFromDb = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).where('fileName').equals(fileName).toArray()];
                    case 2:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_12 = _a.sent();
                        console.log('db error getOfflineFilmFile 1', { error: error_12 });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 21];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 19, , 20]);
                        return [4 /*yield*/, this.api.getInteractionSharedAccessSignature(campaignId, fileName)];
                    case 6:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 14];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas.uri)];
                    case 8:
                        res2 = _a.sent();
                        return [4 /*yield*/, res2.blob()];
                    case 9:
                        blob = _a.sent();
                        fileItem = {
                            id: fileName,
                            fileName: fileName,
                            storedAt: Date.now(),
                            blob: blob
                        };
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).put(fileItem)];
                    case 11:
                        _a.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        error_13 = _a.sent();
                        console.log('db error getOfflineInteractionFile 1', { error: error_13 });
                        return [3 /*break*/, 13];
                    case 13: return [3 /*break*/, 18];
                    case 14:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 17];
                        return [4 /*yield*/, this._authRenewal()];
                    case 15:
                        _a.sent();
                        return [4 /*yield*/, this.getOfflineInteractionFile(campaignId, fileName, false)];
                    case 16:
                        campaigns = _a.sent();
                        return [2 /*return*/, campaigns];
                    case 17: throw new errors_1.PermissionError('Invalid access token');
                    case 18: return [3 /*break*/, 20];
                    case 19:
                        error_14 = _a.sent();
                        throw new errors_1.PermissionError(error_14.message);
                    case 20: return [3 /*break*/, 22];
                    case 21:
                        blob = blobFromDb[0].blob;
                        _a.label = 22;
                    case 22: return [4 /*yield*/, URL.createObjectURL(blob)];
                    case 23:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    return FileAccess;
}());
;
exports.default = FileAccess;
//# sourceMappingURL=FileAccess.js.map